import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { useToast } from '../../controller/ToastController';
import { AuthContext } from '../../navigation/AuthProvider';
import { fcmConciergeCountState, fcmSalesCountState } from '../../recoil/fcmMessage';
import { useConciergeState } from '../../recoil/concierge';
import { useInterphoneState } from '../../recoil/interphone';
import { SelectType } from '../../components/DropdownSelect';

type titleType = {
  title: string;
  content: string;
};
interface AccordionItem {
  title: string;
  link?: string;
  content?: { link: string; title: string }[];
}

interface MobileSidebarProps {
  isOpen: boolean;
  toggle: () => void;
  setIsOpen: any;
  currentStore: SelectType;
  currentTitle: titleType;
  accordionData: AccordionItem[];
  loadNewWindow: any;
  isUnReadNotice: boolean;
}

const MobileSidebar = ({
  isOpen,
  toggle,
  currentStore,
  currentTitle,
  accordionData,
  setIsOpen,
  loadNewWindow,
  isUnReadNotice,
}: MobileSidebarProps) => {
  const oAuthContext = useContext(AuthContext);
  const showToast = useToast();
  const fcmSalesCount = useRecoilValue(fcmSalesCountState);
  const fcmConciergeCount = useRecoilValue(fcmConciergeCountState);
  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);

  const doLogout = () => {
    oAuthContext.handleLogout();
  };

  const Header = () => {
    return (
      <div className="header">
        <div className="logoWrap">
          <img
            src={`${process.env.PUBLIC_URL}/img/knockLogo_gold.png`}
            alt="노크노크로고"
            width="100%"
            height="100%"
          />
          <p>HOTELIER</p>
        </div>
        <h2>{currentStore.name}</h2>
        <Link to={'/sales/monthly'}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`}
            width="30px"
            height="30px"
            alt="홈 바로가기"
            className="home"
          />
          <p>홈으로 가기</p>
        </Link>
      </div>
    );
  };

  return (
    <div>
      <Style>
        <div className="headerIconWrap">
          <button onClick={toggle}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_hamburgerbar.svg`}
              width="28px"
              height="28px"
              alt="햄버거바"
            />
          </button>
        </div>
      </Style>
      <SideBarWrap open={isOpen}>
        {/* <Sidebar /> */}
        <div className="sidebarWrap">
          <Header />
          {oAuthContext.userInfo.role_id === 0 ? (
            <div>
              <div className="side_title">
                <div className="side_title">
                  <h2>매장 관리</h2>
                </div>
                <div className="side_title">
                  <div className="side_title">
                    <h2>매출 관리</h2>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="sidebarContentWrap">
              {accordionData.map((accordion: AccordionItem, index: number) => {
                return (
                  <div className="wrapper" key={index}>
                    <Link to={accordion.link!}>
                      <div
                        className={`title ${
                          currentTitle.title === accordion.title
                            ? accordion.content
                              ? 'select'
                              : 'active'
                            : ''
                        }`}
                        onClick={() =>
                          setActiveAccordion(activeAccordion === index ? null : index)
                        }>
                        <div className="row">
                          <h3>{accordion.title}</h3>
                          {((accordion.title === '판매 관리' && fcmSalesCount > 0) ||
                            (accordion.title === '객실 관리' && fcmConciergeCount > 0) ||
                            (accordion.title === '공지사항' && isUnReadNotice)) && (
                            <div className="countWrap">
                              <p>N</p>
                            </div>
                          )}
                        </div>
                        {accordion.content && activeAccordion === index ? (
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey_ce.svg`}
                            width="20px"
                            height="20px"
                            alt="더보기 화살표"
                          />
                        ) : (
                          activeAccordion !== index && (
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_white.svg`}
                              width="20px"
                              height="20px"
                              alt="더보기 화살표"
                            />
                          )
                        )}
                      </div>
                    </Link>
                    {activeAccordion === index && accordion.content && (
                      <div
                        className="subTitle"
                        style={{ height: `${accordion.content.length * 52}px` }}>
                        {accordion.content &&
                          accordion.content.map((item: AccordionItem, itemIndex: number) => (
                            <>
                              {item.link === 'preparing' ? (
                                <div
                                  onClick={() => {
                                    showToast('사용하지 않는 기능입니다.', 'error', 1000);
                                  }}>
                                  <div
                                    className={`titleLink ${
                                      currentTitle.content === item.title && 'active'
                                    }`}>
                                    <h3>• {item.title}</h3>
                                  </div>
                                </div>
                              ) : (
                                <Link to={item.link || '/'} key={itemIndex}>
                                  <div
                                    className={`titleLink ${
                                      currentTitle.content === item.title && 'active'
                                    }`}>
                                    <h3>• {item.title}</h3>
                                    {item.link &&
                                      item.link === '/manage/salemanager' &&
                                      fcmSalesCount > 0 && (
                                        <div className="countWrap">
                                          <p>{fcmSalesCount > 99 ? '99+' : fcmSalesCount}</p>
                                        </div>
                                      )}
                                    {item.link &&
                                      item.link === '/room/request' &&
                                      fcmConciergeCount > 0 && (
                                        <div className="countWrap">
                                          <p>
                                            {fcmConciergeCount > 99 ? '99+' : fcmConciergeCount}
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </Link>
                              )}
                            </>
                          ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
          <div className="bottomWrap">
            <Link to={'/room/device'}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_device.svg`} alt="기기관리" />
              <h3>노크노크 기기 관리</h3>
            </Link>
            <Link to={'/notification/list'}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_notice.svg`} alt="공지사항" />
              <h3>공지사항</h3>
            </Link>
            <button onClick={doLogout}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_logout.svg`} alt="로그아웃" />
              <h3>로그아웃</h3>
            </button>
            <button className="functionButton" onClick={loadNewWindow}>
              <h3>직영매장 바로가기</h3>
            </button>
          </div>
        </div>
      </SideBarWrap>
    </div>
  );
};

export default MobileSidebar;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  button {
    padding: 0;
    margin: 0;
  }
`;
const SideBarWrap = styled.div<{ open: boolean }>`
  .sidebarWrap {
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: #2b2b2b;
    width: ${({ open }) => (open ? '250px' : '0')};
    white-space: nowrap;
    position: absolute;
    overflow-y: auto;
    top: 0;
    left: 0;
    opacity: 1;
    transition: width 0.3s ease-in-out;
    padding: 24px 0;
    background: #2b2b2b;
  }

  .header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 2px solid #383838;

    h2 {
      font-size: 16px;
      font-weight: 400;
      color: #f6e7b4;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  .logoWrap {
    padding: 6px 0;
    margin: 0 16px;
    border: 1px solid #f6e7b4;
    border-radius: 14px;
    background: #2b2b2b;
    img {
      height: 16px;
      object-fit: contain;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 200;
      color: #f6e7b4;
    }
  }

  /* sidebarContentWrap */
  .sidebarContentWrap {
    padding: 0 8px;
    flex: 1;
  }
  .sidebarContentWrap .title {
    margin: 11px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px 10px 18px;

    h3 {
      font-size: 18px;
      color: #cecece;
      font-weight: 500;
    }
  }
  .title.select {
    margin: 11px 0;
    background: #333a38;
    border-radius: 5px;
  }
  .title.active {
    background: #4dd2ae;
    border-radius: 5px;
  }
  .title.select,
  .title.active h3 {
    color: #fff;
    font-weight: 400;
  }

  .subTitle {
    min-height: 100%;
    height: inherit;
    animation: expandDown 0.3s ease-out;
  }

  .countWrap {
    margin: -10px 0 0 8px;
    width: 20px;
    height: 20px;
    background: #ff6060;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-size: 12px;
      line-height: 12px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .subTitle .titleLink {
    display: flex;
    width: 100%;
    padding: 12px 21px;

    h3 {
      color: #cecece;
      font-weight: 400;
      font-size: 18px;
    }

    .countWrap {
      margin: -4px 0 0 6px;
    }
  }
  .titleLink.active {
    background: #4dd2ae;
    border-radius: 5px;

    h3 {
      color: #fff;
    }
  }

  .bottomWrap {
    border-top: 2px solid #383838;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    h3 {
      color: #cecece;
      font-weight: 500;
    }
    button,
    a {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 0;
      cursor: pointer;
    }
  }

  .functionButton {
    margin-top: 24px;
    border-radius: 5px;
    padding: 6px 0 !important;
    border: 1px solid #4dd2ae;
    justify-content: center;

    h3 {
      font-size: 16px;
      color: #4dd2ae;
      font-weight: 600;
    }
  }
`;
